import TableComponent from "../../components/organism/Table/TableComponent";
import { FC, useMemo } from "react";
import { Column } from "react-table";
import {
  MONTH_NAMES,
  SEMESTRAL_NAMES,
  TRIMESTRAL_NAMES,
} from "../../utils/constants";

interface TableIndicatorHistoryProps {
  dataTable: any[];
  isLoaded: boolean;
  frequencyId: number;
}

const TableIndicatorHistory: FC<TableIndicatorHistoryProps> = ({
  dataTable,
  isLoaded,
  frequencyId,
}) => {
  const columns = useMemo(() => {
    const baseColumns: Column[] = [
      {
        Header: "Ano",
        accessor: (row: any, rowIndex: number) => {
          return rowIndex === 0 ? (
            <strong>
              Variação homóloga
              <br />
              ano anterior
            </strong>
          ) : (
            <strong>{row.year || "-"}</strong>
          );
        },
        disableSortBy: true,
      },
    ];

    if (frequencyId === 3) {
      MONTH_NAMES.forEach((month, index) => {
        baseColumns.push({
          Header: month,
          accessor: (row: any) => {
            const period = row.datas.find(
              (data: any) => data.dataPeriod.id === index + 1,
            );
            if (!period) {
              return "-";
            }
            const value =
              period.value !== undefined && period.value !== null
                ? period.value.toFixed(1)
                : "-";
            if (row.year === 0 && value !== "-") {
              return `${value}%`;
            }
            return value;
          },
          disableSortBy: true,
        });
      });
    } else if (frequencyId === 4) {
      TRIMESTRAL_NAMES.forEach((trimestral, index) => {
        baseColumns.push({
          Header: trimestral,
          accessor: (row: any) => {
            const period = row.datas.find(
              (data: any) => data.dataPeriod.id === index + 13,
            );
            if (!period) {
              return "-";
            }
            const value =
              period.value !== undefined && period.value !== null
                ? period.value.toFixed(1)
                : "-";
            if (row.year === 0 && value !== "-") {
              return `${value}%`;
            }
            return value;
          },
          disableSortBy: true,
        });
      });
    } else if (frequencyId === 5) {
      SEMESTRAL_NAMES.forEach((semestral, index) => {
        baseColumns.push({
          Header: semestral,
          accessor: (row: any) => {
            const period = row.datas.find(
              (data: any) => data.dataPeriod.id === index + 17,
            );
            if (!period) {
              return "-";
            }
            const value =
              period.value !== undefined && period.value !== null
                ? period.value.toFixed(1)
                : "-";
            if (row.year === 0 && value !== "-") {
              return `${value}%`;
            }
            return value;
          },
          disableSortBy: true,
        });
      });
    } else if (frequencyId === 6) {
      baseColumns.push({
        Header: "Valor",
        accessor: (row: any) => {
          const value = row.datas?.[0]?.value;
          if (value !== undefined && value !== null) {
            const roundedValue = value.toFixed(1);
            if (row.year === 0) {
              return `${roundedValue}%`;
            }
            return roundedValue;
          }
          return "-";
        },
        disableSortBy: true,
      });
    }

    return baseColumns;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <TableComponent
      isLoaded={isLoaded}
      columns={columns}
      data={dataTable}
      highlightedRows={[0]}
    />
  );
};

export default TableIndicatorHistory;
